import { Payload } from './Payload';

type EventCallback = (payload: Payload) => void;
type NativeEventName = 'callNative' | 'callJavaScript';

class NativeEvent {
  name: NativeEventName;
  callbacks: EventCallback[];
  constructor(name: NativeEventName) {
    this.name = name;
    this.callbacks = [];
  }

  registerCallback(callback: EventCallback): void {
    this.callbacks.push(callback);
  }

  unRegisterCallback(callback: EventCallback): void {
    const index = this.callbacks.findIndex(eventCallback => eventCallback === callback);
    this.callbacks.splice(index, 1);
  }

  resetCallbacks(): void {
    this.callbacks = []
  }
}

class NativeEventHandler {
  events = {
    callNative: new NativeEvent('callNative'),
    callJavaScript: new NativeEvent('callJavaScript'),
  };

  dispatchEvent(name: NativeEventName, payload: Payload) {
    this.events[name].callbacks.forEach((callback: EventCallback) => callback(payload));
  }

  on(name: NativeEventName, callback: EventCallback): void {
    this.events[name].registerCallback(callback);
  }

  off(name: NativeEventName, callback: EventCallback): void {
    this.events[name].unRegisterCallback(callback)
  }

  removeAllListeners(): void {
    Object.values(this.events).forEach(event => event.resetCallbacks());
  }
}

export {
  NativeEventHandler,
};
